/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Model with statistics of invites for a specific case.
 */
export interface ClientInviteStatisticForCaseModel { 
    /**
     * How many users was invited.
     */
    invited: number;
}

